import React, { Component } from "react";

export class Calendar extends Component {
  render() {
    return (
      <div>
        <h1>Calendar Page</h1>
      </div>
    );
  }
}

export default Calendar;
